export default __webpack_public_path__ + "img/ejendom-top-bar.webp";